module.exports = __webpack_public_path__ + "images/418c97245bd1e05de9bb80318cb49784.png";